import { render, staticRenderFns } from "./appIframe.vue?vue&type=template&id=eca3c118&scoped=true"
import script from "./appIframe.vue?vue&type=script&lang=js"
export * from "./appIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca3c118",
  null
  
)

export default component.exports